import React from 'react';
import { TFunction } from 'react-i18next';
import {
  errorBoundary,
  withInject,
} from '@piwikpro/platform';
import {
  Layout,
  Card,
  View,
  withTranslation,
} from '@piwikpro/ui-components';
import PasswordChange from './PasswordChange';
import TwoFactorAuth from './TwoFactorAuth';

export interface ISecurityProps {
  Title: typeof React.Component
  t: TFunction
}

export const Security: React.FC<ISecurityProps> = ({
  Title,
  t,
}) => (
  <Title part={t('security.title')}>
    <View>
      <View.Header title={t('security.title')} />
      <View.Body>
        <PasswordChange />
        <Layout>
          <Layout.AnnotatedSection title={t('security.2fa.section.title')} />
          <Layout.Column dominant>
            <Card>
              <Card.Section>
                <TwoFactorAuth />
              </Card.Section>
            </Card>
          </Layout.Column>
        </Layout>
      </View.Body>
    </View>
  </Title>
);

export default withInject({
  config: 'config',
  users: 'UsersCrate.users',
  validation: 'FormCrate.validation',
  Title: 'TitleCrate.components.Title',
})(withTranslation(['profile', 'platform'])(errorBoundary(Security)));
